
type SortProps = {
    label: string,
    sortProperty: string,
    sortDefaultAsc: boolean,
    sortSelection: ISortSelection
    onClick: (selection: ISortSelection) => void
}

export interface ISortSelection {
    sortProperty: string,
    sortAsc: boolean
}

export function sortList<T>(list: T[], sortSelection: ISortSelection) {
    let direction = sortSelection.sortAsc === false ? -1 : 1;
    let prop = sortSelection.sortProperty;

    let sorted = list.sort((x, y) => {
        let result = 0;
        if (x.hasOwnProperty(prop) && y.hasOwnProperty(prop)) {
            if (isNaN(x[prop]) || isNaN(y[prop])) {
                result = direction * x[prop].toString().localeCompare(y[prop].toString());
            }
            else {
                result = direction * (Number(x[prop]) - Number(y[prop]));
            }
        }
        return result;
    });

    return sorted;
}

export const SortHeader = (props: SortProps) => {
    let isSortedAlready = props.sortSelection.sortProperty == props.sortProperty;
    let sortAsc = props.sortDefaultAsc !== false;

    let selection = {
        sortProperty: props.sortProperty,
        sortAsc: !isSortedAlready ? sortAsc : !props.sortSelection.sortAsc
    } as ISortSelection;
    
    let glyphicon = props.sortSelection.sortAsc ? "glyphicon glyphicon-triangle-top" : "glyphicon glyphicon-triangle-bottom";

    return (
        <>
            <div style={{ cursor: "pointer" }} className="sort-header" onClick={() => props.onClick(selection)}>
                {props.sortSelection.sortProperty == props.sortProperty &&
                    <><span className={glyphicon} aria-hidden="true"></span>&nbsp;</>
                }
                {props.label}
            </div>
        </>
    );
}